export const sdkWrapperURL = (url = "") => new URL(url, "https://retail-api-dev-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") => new URL(url, "https://sdk-dev.carenow.healthcare");
